"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var translate_1 = __importDefault(require("../../../../app/localization/translate"));
var dateUtils_1 = require("../../../../youwell-common/dateUtils");
var image_1 = require("../../../../common/image");
var styles = function (theme) {
    var _a, _b, _c;
    return (0, core_1.createStyles)({
        box: (_a = {
                marginBottom: theme.spacing(4),
                boxShadow: theme.shadows[2],
                backgroundColor: theme.palette.background.default,
                borderRadius: theme.youwell.shapes.borderRadius
            },
            _a[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(2),
            },
            _a),
        entry: {
            '&+&': {
                marginTop: theme.spacing(6),
            },
        },
        entryLabelFlexWrapper: (_b = {
                marginBottom: theme.spacing(1),
                display: 'flex'
            },
            _b[theme.breakpoints.down('xs')] = {
                flexDirection: 'column',
            },
            _b),
        textAndIconWrapper: {
            display: 'flex',
        },
        entryLabel: {
            marginRight: theme.spacing(2),
        },
        entryTitle: {},
        input: {
            backgroundColor: theme.palette.common.white,
        },
        selectInput: {
            border: theme.youwell.borders.dim,
            width: 200,
            height: 50,
            textAlign: 'center',
            margin: theme.spacing(1, 2, 1, 0),
            '& .MuiSelect-selectMenu': {
                display: 'flex',
                justifyContent: 'center',
            },
        },
        selectInputMenuItem: {
            display: 'flex',
            justifyContent: 'center',
        },
        yesNoRadioBtns: {
            border: theme.youwell.borders.secondary,
            margin: theme.spacing(2, 2, 2, 0),
            padding: theme.spacing(1, 16, 1, 1),
        },
        alwaysPresentContent: {
            padding: theme.spacing(4),
            borderRadius: theme.youwell.shapes.borderRadius,
        },
        toggleableContent: (_c = {
                backgroundColor: "".concat(theme.palette.secondary.main, "20"),
                padding: theme.spacing(5),
                margin: '0 auto'
            },
            _c[theme.breakpoints.down('xs')] = {
                maxWidth: '100%',
                padding: theme.spacing(2, 1),
            },
            _c),
        radioGroup: {
            display: 'flex',
            padding: theme.spacing(1, 0, 3, 0),
        },
        rowContainer: {
            flexDirection: 'row',
        },
        hoursAndMinutesInput: {
            display: 'flex',
            alignItems: 'center',
        },
        hoursAndMinutesInputHelperText: {
            padding: theme.spacing(0, 2, 0, 1),
        },
        numberOfWakeups: {
            backgroundColor: theme.palette.common.white,
            marginLeft: theme.spacing(1),
        },
    });
};
var useStyles = (0, core_1.makeStyles)(function (theme) { return styles(theme); }, { name: 'LogWakeups' });
var numberOfWakeups = [1, 2, 3, 4, 5];
var hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var minutes = [0, 10, 20, 30, 40, 50];
var LogWakeups = function (_a) {
    var _b, _c, _d;
    var values = _a.values, handleValueChange = _a.handleValueChange, disabled = _a.disabled;
    var classes = useStyles();
    var translate = (0, translate_1.default)();
    var timeValues = (0, dateUtils_1.getTimeValues)((_b = values.sleepProperties) === null || _b === void 0 ? void 0 : _b.nightWakeupsTotalMinutes);
    var handleNumberOfWakeupsChange = function (event) {
        var _a;
        var val = Number(event.target.value) || 0;
        var updated = __assign(__assign({}, values.sleepProperties), { numberOfNightWakeups: val, nightWakeupsTotalMinutes: val === 0 ? 0 : (_a = values.sleepProperties) === null || _a === void 0 ? void 0 : _a.nightWakeupsTotalMinutes });
        handleValueChange('sleepProperties')(updated);
    };
    var handleHoursChange = function (event) {
        var val = Number(event.target.value) || 0;
        var updated = __assign(__assign({}, values.sleepProperties), { nightWakeupsTotalMinutes: val * 60 + timeValues.minutes });
        handleValueChange('sleepProperties')(updated);
    };
    var handleMinutesChange = function (event) {
        var val = Number(event.target.value) || 0;
        var updated = __assign(__assign({}, values.sleepProperties), { nightWakeupsTotalMinutes: timeValues.hours * 60 + val });
        handleValueChange('sleepProperties')(updated);
    };
    var hasNighWakeups = ((_c = values.sleepProperties) === null || _c === void 0 ? void 0 : _c.numberOfNightWakeups) !== undefined && values.sleepProperties.numberOfNightWakeups > 0;
    var hasNoNighWakeups = ((_d = values.sleepProperties) === null || _d === void 0 ? void 0 : _d.numberOfNightWakeups) !== undefined && values.sleepProperties.numberOfNightWakeups === 0;
    return (React.createElement("div", { className: classes.box },
        React.createElement("div", { className: classes.alwaysPresentContent },
            React.createElement("div", { className: classes.entry },
                React.createElement("div", { className: classes.entryLabelFlexWrapper },
                    React.createElement("div", { className: classes.textAndIconWrapper },
                        React.createElement(core_1.Typography, { variant: "subtitle2", className: classes.entryLabel }, translate('sleepDiary.nightWakeups')),
                        React.createElement(image_1.AwakeSmileyIcon, null))),
                React.createElement(core_1.RadioGroup, { className: (0, classnames_1.default)(classes.radioGroup, classes.rowContainer), onChange: handleNumberOfWakeupsChange },
                    React.createElement(core_1.FormControlLabel, { className: (0, classnames_1.default)(classes.yesNoRadioBtns, classes.input), value: 0, control: React.createElement(core_1.Radio, { checked: hasNoNighWakeups }), label: translate('sleepDiary.no'), disabled: disabled }),
                    React.createElement(core_1.FormControlLabel, { className: (0, classnames_1.default)(classes.yesNoRadioBtns, classes.input), value: 1, control: React.createElement(core_1.Radio, { checked: hasNighWakeups }), label: translate('sleepDiary.yes'), disabled: disabled })))),
        hasNighWakeups && (React.createElement("div", { className: classes.toggleableContent },
            React.createElement(core_1.Typography, { variant: "subtitle2", className: classes.entryTitle }, translate('sleepDiary.howManyTimesAwakeAtNight')),
            React.createElement(core_1.RadioGroup, { className: classes.radioGroup, onChange: handleNumberOfWakeupsChange }, numberOfWakeups.map(function (value) {
                var _a;
                return (React.createElement(core_1.FormControlLabel, { className: classes.numberOfWakeups, disabled: disabled, key: value, value: value, control: React.createElement(core_1.Radio, { checked: ((_a = values.sleepProperties) === null || _a === void 0 ? void 0 : _a.numberOfNightWakeups) === value }), label: translate("sleepDiary.howOftenAwake.".concat(value)) }));
            })),
            React.createElement(core_1.Typography, { variant: "subtitle2", className: classes.entryTitle }, translate('sleepDiary.howLongAwakeAtNight')),
            React.createElement("div", { className: classes.hoursAndMinutesInput },
                React.createElement(core_1.Select, { type: "number", className: (0, classnames_1.default)(classes.selectInput, classes.input), value: timeValues.hours, onChange: handleHoursChange, disabled: disabled, disableUnderline: true, MenuProps: {
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                        },
                        getContentAnchorEl: null,
                    } }, hours === null || hours === void 0 ? void 0 : hours.map(function (item) { return (React.createElement(core_1.MenuItem, { className: classes.selectInputMenuItem, key: item, value: item },
                    item,
                    item === 1 ? (React.createElement(core_1.Typography, { className: classes.hoursAndMinutesInputHelperText, variant: "body2" }, translate('time.hour')))
                        : (React.createElement(core_1.Typography, { className: classes.hoursAndMinutesInputHelperText, variant: "body2" }, translate('time.hours'))))); })),
                React.createElement(core_1.Select, { type: "number", className: (0, classnames_1.default)(classes.selectInput, classes.input), value: timeValues.minutes, onChange: handleMinutesChange, disabled: disabled, disableUnderline: true, MenuProps: {
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                        },
                        getContentAnchorEl: null,
                    } }, minutes === null || minutes === void 0 ? void 0 : minutes.map(function (item) { return (React.createElement(core_1.MenuItem, { className: classes.selectInputMenuItem, key: item, value: item },
                    item,
                    item === 1 ? (React.createElement(core_1.Typography, { className: classes.hoursAndMinutesInputHelperText, variant: "body2" }, translate('time.minute')))
                        : (React.createElement(core_1.Typography, { className: classes.hoursAndMinutesInputHelperText, variant: "body2" }, translate('time.minutes'))))); })))))));
};
exports.default = LogWakeups;
